import React from 'react';

import { Box, CircularProgress } from '@mui/material';

type Props = {
  mt?: number;
};

export default function SectionLoader({ mt = 0 }: Props) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4, mt }}>
      <CircularProgress size={32} />
    </Box>
  );
}
